import styled, { css } from 'styled-components';
import { IconWrapperProps } from './styles.types';

export const IconWrapper = styled.div<IconWrapperProps>`
    color: ${props => props.color || '#fff'};
    text-shadow: rgba(0, 0, 0, 0.6) 1px 0px 0px, rgba(0, 0, 0, 0.6) 0.5403px 0.84147px 0px, rgba(0, 0, 0, 0.6) -0.41615px 0.9093px 0px, rgba(0, 0, 0, 0.6) -0.98999px 0.14112px 0px, rgba(0, 0, 0, 0.6) -0.65364px -0.7568px 0px, rgba(0, 0, 0, 0.6) 0.28366px -0.95892px 0px, rgba(0, 0, 0, 0.6) 0.96017px -0.27942px 0px;
    ${props =>
      props.noshadow &&
      css`
        text-shadow: none;
      `}
    transform: rotate(${props => props.rotate}deg);
    font-size: ${props => props.size + 'px' || 'inherit'};
    width: ${props => props.size}px;
    vertical-align: middle;
    display: inline-block;
    height: ${props => props.size}px;
    text-align: center;
    border-radius: ${props => props.size}px;
    background: ${props => props.bg};
    line-height: ${props => props.size}px;
    ${props =>
      props.size &&
      css`
        font-size: ${props.size / 2}px;
      `}

`;
